import { Sentry } from "@/instrument";

export const handleChatError = (
  error: Error,
  context: string,
  extra?: Record<string, any>,
) => {
  console.error(`Chat error in ${context}:`, error);

  Sentry.captureException(error, {
    tags: {
      component: "chat-manager",
      context,
    },
    extra,
  });
};
